<div class="grid">
    <div class="column1">
        <ul class="list-results">
            <h2>Authors</h2>
            <li>
                <div *ngIf="!eventsService.keepFocus">
                    <button (click)="addEvent()">+ Add New Event</button>
                </div>
            </li>

            <li *ngFor="let event of allEvents | async">
                <div *ngIf="event == eventsService.selectedEvent; else notSelected">
                    <span class="selected" (click)="selectEvent(event)">{{event.name}}</span>
                </div>
                <ng-template #notSelected>
                    <div *ngIf="!eventsService.keepFocus">
                        <button (click)="selectEvent(event)">{{event.name}}</button>
                    </div>
                </ng-template>
            </li>
        </ul>
    </div>

    <div class="seperator-line"></div>

    <div class="column2">
        <ng-container *ngIf="eventsService.selectedEvent">
            <app-selected-event [selectedEvent]="eventsService.selectedEvent"> </app-selected-event>
        </ng-container>
        <ng-container *ngIf="eventsService.addingNewEvent">
            <app-new-event></app-new-event>
        </ng-container>
    </div>
</div>